import { getSendErrorMessage } from 'src/services/api/utils/get-send-error-message';

const DEFAULT_ERROR_MESSAGE = 'Failed to send';

/**
 * Maps an error thrown while sending a single message in a bulk send to a
 * message safe to show a landlord. Thin wrapper around the shared
 * `getSendErrorMessage` helper - see that file for the invariant it enforces.
 */
export const getBulkSendErrorMessage = (error: any): string =>
    getSendErrorMessage(error, DEFAULT_ERROR_MESSAGE);
